import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import AppView from '~common/components/app-view/index';
import * as request from 'superagent';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import QueryList from '~common/components/query-fulfillment/query-list-fc';

import portalUserContext from '~common/lib/portal-user-context';
import URLManager from '~common/lib/url-manager';
import JsonLabel from '../../../../../common/ui/components/json-label-fc';
import { saveAs } from "file-saver";

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: 'loading' | 'ready';
  error?: any;
};

class FormAdminQueryList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
    };
  }

 componentDidMount() {
    // console.log("Into TSX")
  }

  handleActionsForItemRow = (row: any) => {
    var actions = Array<any>()

    actions.push({
      label: 'Export Form',
      // Previously a drop down in legacy app, downloads file. 
      onClick: (evt:any)=> {
        if (evt && evt.id) {
          this.handleExportForm([evt.id])
        }
      }
    })
  
    return actions
  }

  summaryAction = (selectedItems: any) => {
    return [
      {
        label: "Export Selected",
        onClick: this.handleExportMany,
        templateSelector: {"module": "formAdmin", "templateType": "formMigrationExport"},
      },
    ];
  };

  handleExportMany = (forms:any) => {
    var ids:Array<number> = forms.map((form:any)=>{
      return form.id
    })
    if (ids.length > 0){
      this.setState({
        "status": "ready"
      }, this.handleExportForm(ids))
      
    }
  }

  handleExportForm = (formIDs:Array<any>) => {
    // const {form} = this.state
    request.post(`/api/form-definitions/export`)
    .responseType("blob")
    .send(formIDs)
    .then((response: request.Response)=>{
      let filename = "formDef.sql";

        let disposition = response["headers"]["content-disposition"];
        if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }

      saveAs(response.body, filename);
    })
  }

  handleRowClick = (item) => {
    var criteria = URLManager.getQueryString(window.location.href)
    window.location.href = `/forms/admin/${item.id}`
  }

  
  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {status} = this.state;

    var criteriaSelector = {
      "app": "admin",
      "formType": "formDefinitionCriteria",
      "module":"forms"
    }

    criteriaSelector["userType"] = portalUserContext.userType
    if (criteriaSelector["userType"] == "Portal Admin") {
      criteriaSelector["userType"] = "Internal"
    }

    switch (status) {
      case 'loading':
        return (
          <AppView>
            <div className={classes.container}>
              <LoadingView classes={
                {}
              } />
            </div>
          </AppView>
        );
      default:
        return (
          <AppView>
            <div className={classes.container}>
                <QueryList
                history={this.props.history}
                  criteriaFormSelector={criteriaSelector}
                  resultsFormSelector={
                    {
                      "app":"admin",
                      "form":"formDefinitionResults",
                      "module":"forms"
                    }
                  }
                  queryUrl="/api/form-definitions/query"
                  autoQuery={true}
                  forceExecuteOnLoad={true}
                  supressSectionStatusIcon
                  actionsForItemRow={this.handleActionsForItemRow}
                  onRowClick={this.handleRowClick}
                  alwaysExecuteOnSubmit={true}
                  customRenderers={{"JsonLabel":JsonLabel}}
                  // excludeFromClear={["supplierID","vendorNbrs"]}
                  noResultsText="No Results Found"
                  actionsForSelectedItems={this.summaryAction}
              />
            </div>
          </AppView>
        );
    }
  }
}

export default withStyles(styles)(FormAdminQueryList);



